import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "schedule-bus-form" }
const _hoisted_2 = { class: "title-form py-5 flex items-center justify-between" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = {
  class: "p-fluid px-3",
  style: {"height":"75vh","overflow-y":"scroll"}
}
const _hoisted_5 = { class: "p-field mb-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "scheduleCode" }, "Kode Jadwal", -1)
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = { class: "p-field mb-4" }
const _hoisted_9 = { for: "activeDate" }
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = {
  key: 0,
  class: "p-field mb-4"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "inactiveDate" }, "Tanggal Berhenti", -1)
const _hoisted_13 = {
  key: 0,
  class: "p-error"
}
const _hoisted_14 = { class: "p-field mb-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { for: "typeBus" }, "Bagasi", -1)
const _hoisted_16 = {
  key: 0,
  class: "p-error"
}
const _hoisted_17 = { class: "p-field mb-4" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { for: "rit" }, "Pilih RIT", -1)
const _hoisted_19 = {
  key: 0,
  class: "p-error"
}
const _hoisted_20 = { class: "p-field mb-4" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { for: "ket" }, "Keterangan", -1)
const _hoisted_22 = { class: "p-field mb-4" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { for: "agentShow" }, "Tampilkan Pada Agent", -1)
const _hoisted_24 = {
  key: 1,
  class: "p-field"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { for: "idActive" }, "Aktif", -1)
const _hoisted_26 = {
  class: "btn-action w-full",
  style: {"position":"absolute","bottom":"10px"}
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h6", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_InputText, {
          id: "scheduleCode",
          class: "input-primary mt-1 uppercase",
          name: "scheduleCode",
          modelValue: _ctx.v$.scheduleCode.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.scheduleCode.$model = $event)),
          type: "text"
        }, null, 8, ["modelValue"]),
        ((_ctx.v$.scheduleCode.$invalid && _ctx.submitted) || _ctx.v$.scheduleCode.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_7, _toDisplayString(_ctx.v$.scheduleCode.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("label", _hoisted_9, _toDisplayString(_ctx.inAction === 'duplicateData' ? 'Tanggal Mulai' : 'Tanggal Aktif'), 1),
        _createVNode(_component_Calendar, {
          id: "activeDate",
          class: "input-primary mt-1",
          dateFormat: "dd-mm-yy",
          modelValue: _ctx.v$.activeDate.$model,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.activeDate.$model = $event)),
          placeholder: "dd-mm-yyyy"
        }, null, 8, ["modelValue"]),
        ((_ctx.v$.activeDate.$invalid && _ctx.submitted) || _ctx.v$.activeDate.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_10, _toDisplayString(_ctx.v$.activeDate.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.inAction == 'duplicateData')
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Calendar, {
              id: "inactiveDate",
              class: "input-primary mt-1",
              dateFormat: "dd-mm-yy",
              modelValue: _ctx.v$.inactiveDate.$model,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.inactiveDate.$model = $event)),
              placeholder: "dd-mm-yyyy"
            }, null, 8, ["modelValue"]),
            ((_ctx.v$.inactiveDate.$invalid && _ctx.submitted) || _ctx.v$.inactiveDate.$pending.$response)
              ? (_openBlock(), _createBlock("small", _hoisted_13, _toDisplayString(_ctx.v$.inactiveDate.required.$message), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_Multiselect, {
          id: "typeBus",
          class: "mt-1",
          modelValue: _ctx.v$.typeBus.$model,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.typeBus.$model = $event)),
          placeholder: "Pilih Bagasi",
          options: _ctx.typeBusOption,
          searchable: true
        }, null, 8, ["modelValue", "options"]),
        ((_ctx.v$.typeBus.$invalid && _ctx.submitted) || _ctx.v$.typeBus.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_16, _toDisplayString(_ctx.v$.typeBus.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_Multiselect, {
          id: "rit",
          class: "mt-1",
          modelValue: _ctx.v$.rit.$model,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.rit.$model = $event)),
          placeholder: "Pilih RIT",
          options: _ctx.ritOption,
          searchable: true
        }, null, 8, ["modelValue", "options"]),
        ((_ctx.v$.rit.$invalid && _ctx.submitted) || _ctx.v$.rit.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_19, _toDisplayString(_ctx.v$.rit.required.$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_20, [
        _hoisted_21,
        _createVNode(_component_Textarea, {
          id: "ket",
          modelValue: _ctx.dataForm.keterangan,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dataForm.keterangan = $event)),
          rows: "5",
          cols: "30",
          class: "mt-1"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_22, [
        _hoisted_23,
        _createVNode("div", null, [
          _createVNode(_component_InputSwitch, {
            id: "agentShow",
            class: "switch-og mt-1",
            modelValue: _ctx.dataForm.agentShow,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataForm.agentShow = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      (_ctx.data)
        ? (_openBlock(), _createBlock("div", _hoisted_24, [
            _hoisted_25,
            _createVNode("div", null, [
              _createVNode(_component_InputSwitch, {
                id: "idActive",
                class: "switch-og mt-1",
                modelValue: _ctx.dataForm.isActive,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dataForm.isActive = $event))
              }, null, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_26, [
      _createVNode(_component_Button, {
        label: "Simpan",
        class: "font-semibold p-button-sm btn-primary px-10 mr-2",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)))
      }),
      _createVNode(_component_Button, {
        class: "btn-secondary text-black p-button-sm px-10 py-1 justify-center",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeSidebar()))
      }, {
        default: _withCtx(() => [
          _hoisted_27
        ]),
        _: 1
      })
    ])
  ]))
}